export default {
    current_choice: '現在の選択',
    book_now: '今すぐ予約する',
    minimum_age: '{age} のみ',
    excess_liability: '過剰な責任',
    security_deposit: '保証金',
    fuel_policy: '燃料政策',
    like_for_like: 'いいねにはいいね',
    full_to_full: 'フルからフルへ',
    miles_per_rental: '{mileage} レンタルごとに無料マイル',
    km_per_rental: '{mileage} レンタルごとに無料キロメートル',
    unlimited_mileage: '走行距離無制限',
    unlimited_mileage_km: '走行距離無制限',
    non_amendable: '修正不可',
    non_refundable: '返金不可',
    free_cancellation_until: 'までキャンセル料無料',
    basic_free_cancellation: '開始時刻の48時間前まで無料でキャンセル',
    cancellation_in_line_with: 'に伴うキャンセル',
    tcs: 'T&amp;Cs',
    free_extras_on_collection: 'コレクションの 2 つの無料特典',
    glass_and_tyres_covered: 'ガラスとタイヤが覆われています',
    number_of_passengers: '乗客数',
    number_of_bags: 'バッグの数',
    fuel_type: '燃料の種類',
    co2: 'CO2',
    aircon: 'エアコン',
    transmission: 'トランスミッション',
    book_type: '予約 {type}',
    debit_card_deposit: 'デビットカードによる入金が可能',
    fast_track_included: 'ファストトラックが含まれています',
    view_all: 'すべて見る',
}
